interface Props {
  children: React.ReactNode
  withVerticalPadding?: boolean
  topSection?: boolean
  className?: string
}

const horizontalPadding = 'px-[32px] md:px-[64px] lg:px-[120px]'
const verticalPadding = 'py-[64px] md:py-[96px] lg:py-[120px]'
const topSectionVerticalPadding = 'pt-[116px] pb-[64px] md:pt-[146px] lg:pt-[168px]'

export default function Section({
  children,
  topSection,
  withVerticalPadding = false,
  className = '',
}: Props) {
  return (
    <div
      className={[
        'transition-all',
        horizontalPadding,
        withVerticalPadding ? (topSection ? topSectionVerticalPadding : verticalPadding) : ' ',
        className,
      ].join(' ')}
    >
      {children}
    </div>
  )
}
